import { render } from "./products-page.vue?vue&type=template&id=318fb6d1&scoped=true"
import script from "./products-page.vue?vue&type=script&lang=js"
export * from "./products-page.vue?vue&type=script&lang=js"

import "./products-page.vue?vue&type=style&index=0&id=318fb6d1&scoped=true&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318fb6d1"]])

export default __exports__